"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _reactDom = require("react-dom");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBUIProvider = require("../HBUIProvider/HBUIProvider");
var _excluded = ["isOpen", "onClose", "children", "placement", "padding", "testIdName", "width", "zIndex"];
var HBCornerPopup = function HBCornerPopup(_ref) {
  var _props$testId, _global$document;
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'right' : _ref$placement,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '20px' : _ref$padding,
    testIdName = _ref.testIdName,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 380 : _ref$width,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useHBUI = (0, _HBUIProvider.useHBUI)(),
    getCornerPopupPortalTarget = _useHBUI.getCornerPopupPortalTarget;
  var testId = (_props$testId = props.testId) !== null && _props$testId !== void 0 ? _props$testId : props.id;
  var containerTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'container',
    componentName: 'HBCornerPopup'
  });
  var animation = placement === 'right' ? RIGHT_ANIMATION : LEFT_ANIMATION;
  var popup = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, isOpen && /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    "data-testid": containerTestId,
    $placement: placement,
    $padding: padding,
    $width: width,
    $zIndex: zIndex
  }, animation), children, onClose && /*#__PURE__*/_react["default"].createElement(CloseButton, {
    testId: "".concat(testId, "-close"),
    testIdName: "".concat(testIdName, "-close"),
    icon: _Close["default"],
    onClick: onClose,
    size: "xs",
    label: "Close",
    buttonTheme: "subtle-invisible"
  })));
  return /*#__PURE__*/(0, _reactDom.createPortal)(popup, getCornerPopupPortalTarget() || ((_global$document = global.document) === null || _global$document === void 0 ? void 0 : _global$document.body));
};
var _default = exports["default"] = HBCornerPopup;
var RIGHT_ANIMATION = createAnimation('right');
var LEFT_ANIMATION = createAnimation('left');
function createAnimation(placement) {
  var x = placement === 'right' ? 20 : -20;
  return {
    transition: {
      duration: 0.3,
      ease: [0.8, 0, 0.2, 1]
    },
    initial: {
      opacity: 0,
      x: x
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: x
    }
  };
}
var Container = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBCornerPopup__Container",
  componentId: "sc-1ny2wk3-0"
})(["border-radius:2px;background-color:", ";box-shadow:0 0 10px 0 rgba(0,18,71,0.08),0 14px 28px 0 rgba(0,18,71,0.15);padding:", ";position:absolute;z-index:", ";overflow:hidden;margin:24px;bottom:0;right:", ";left:", ";width:", "px;min-width:320px;max-width:420px;"], _colors["default"].white, function (props) {
  return props.$padding;
}, function (props) {
  return props.$zIndex;
}, function (props) {
  return props.$placement === 'right' ? '0' : 'auto';
}, function (props) {
  return props.$placement === 'left' ? '0' : 'auto';
}, function (props) {
  return props.$width;
});
var CloseButton = (0, _styledComponents["default"])(_HBIconButton["default"]).withConfig({
  displayName: "HBCornerPopup__CloseButton",
  componentId: "sc-1ny2wk3-1"
})(["position:absolute;top:8px;right:8px;"]);
//# sourceMappingURL=HBCornerPopup.js.map